export default "__VITE_ASSET__7df09dc8__"